import { createSelector } from 'reselect'

const sidebarSelector = state => state.get('sidebar')
const sidebarDockedSelector = state => state.getIn(['sidebar', 'sidebarDocked'])

export const getCollapseSidebarData = createSelector(
  sidebarSelector,
  sidebarImmutable => {
    const sidebar = sidebarImmutable.toJS()
    return sidebar.sidebarCollapse.collapse
  }
)

export const getDocked = createSelector(
  sidebarDockedSelector,
  state => state.get('docked')
)

export const getDockedMobile = createSelector(
  sidebarDockedSelector,
  state => state.get('docked_mobile')
)



// WEBPACK FOOTER //
// ./src/selectors/sidebar/sidebar-selector.js